import React, { useEffect, useState } from 'react'
import { confirmAlert } from "react-confirm-alert";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
} from "reactstrap";
import Breadcrumbs from 'components/Common/BreadcrumbTitle';
import ToastDialog from "components/Common/ToastDialog";
import { useNavigate } from "react-router-dom"
import { addUserDashboardWidget, editUserDashboardWidget, getUserDashboardWidget } from 'http/UAM/userDashboardWidget.helper'
import { getUserDashboardWidgetPermission } from 'http/fundLync/role.helper'
import { decryptedValue } from 'common/utility';

const AdminSetting = () => {
    let userDetails = decryptedValue(localStorage.getItem("user"));
    const [userDashboardWidget, setUserDashboardWidget] = useState({})
    const [userDashboardWidgetKey, setUserDashboardWidgetKey] = useState([])
    const [id, setId] = useState(-1)
    const navigate = useNavigate()
    const [isDefaultSetting, setIsDefaultSetting] = useState(false)
    const [userDashboardWidgetValue, setUserDashboardWidgetValue] = useState({})
    const [toastInfo, setToastInfo] = useState({ showToast: false });

    useEffect(() => {
        (async () => {
            let item = {}
            let val = {}
            try {
                let response = await getUserDashboardWidget({ userId: userDetails.id });
                let result = await getUserDashboardWidgetPermission({ roleName: userDetails.roleName });
                result?.data.forEach((widget) => {
                    if (widget.view_permission == 1) {
                        item[widget.permissionName] = widget.view_permission
                        val[widget.permissionName] = [widget.permissionDisplayname, widget.permissionDescription]
                    }
                })
                if (response.status === true && response.code === 200) {
                    let defaultItem = response.data.rows[0].dashboardWidgets
                    for (const key in defaultItem) {
                        if (item[key]) {
                            item[key] = defaultItem[key]
                        }
                    }
                    setId(response.data.rows[0].id)
                    setIsDefaultSetting(true)
                }
                setUserDashboardWidgetValue(val)
                setUserDashboardWidget(item)
                setUserDashboardWidgetKey(Object.keys(item));

            } catch (error) {
                setUserDashboardWidgetKey([])
            }
        })()
    }, [])

    const handleChange = (e, key) => {
        setUserDashboardWidget((prevDashboardWidget) => {
            prevDashboardWidget[key] = e.target.checked ? 1 : 0
            return prevDashboardWidget
        })
    }
    const handleChangeWidget = () => {
        confirmAlert({
            title: "Confirm",
            message: "Are you sure you want to perform this action?",
            buttons: [
                {
                    label: "Yes",
                    onClick: async () => {
                        let response = {}
                        if (isDefaultSetting) {
                            response = await editUserDashboardWidget({ id, userId: userDetails.id, dashboardWidgets: userDashboardWidget });
                        } else {
                            response = await addUserDashboardWidget({ userId: userDetails.id, dashboardWidgets: userDashboardWidget });
                        }
                        if (response?.status === true && response?.code === 201) {
                            setToastInfo({
                                message: response?.message,
                                showToast: true,
                                role: "success",
                            });
                            navigate(`/${userDetails.roleName}/dashboard`)
                        }
                    },
                    className: "btn btn-success",
                },
                {
                    label: "No",
                    onClick: () => { },
                    className: "btn btn-light",
                },
            ],
        });


    }

    document.title = "Setting | Fundlync";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className='m-20'>
                    <Breadcrumbs title="Widget Setting" />
                    <Row className="vertical-scroll">
                        <Col xs="12">
                            <Card>
                                <CardBody>

                                    <h5 className='mb-3'>Select widget to display on your dashboard</h5>
                                    <div>
                                        {
                                            userDashboardWidgetKey?.map((key) => <div key={`${key}`}>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    defaultChecked={userDashboardWidget[key] == 1}
                                                    onChange={(e) => handleChange(e, key)}
                                                    style={{ borderColor: "#ced4da" }}

                                                />
                                                <label className="ms-3 me-1">
                                                    {userDashboardWidgetValue[key][0]}
                                                </label>
                                                <span
                                                    title={userDashboardWidgetValue[key][1]}
                                                >
                                                    <i className="bx bxs-info-circle text-success" />
                                                </span>
                                            </div>)
                                        }
                                    </div>
                                    <div>
                                        <Button
                                            color="success"
                                            type="submit"
                                            className='mt-2'
                                            onClick={handleChangeWidget}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>

        </React.Fragment>
    )
}

export default AdminSetting
